import PotentialOrderLineDictionary from './PotentialOrderLineDictionary';
import SkuLine from './SkuLine';
import Totals from './Totals';

export default function calculateTotals(
    skusInCategory: SkuLine[],
    potentialOrderLines: PotentialOrderLineDictionary
): Totals {
    const totals = {
        bv: 0,
        pv: 0,
        subTotal: 0,
    };
    // tslint:disable-next-line:forin
    for (const skuNumber in potentialOrderLines) {
        const quantity = potentialOrderLines[skuNumber].quantity;
        if (quantity === 0) {
            continue;
        }
        // tslint:disable-next-line:no-shadowed-variable
        const sku = skusInCategory.find((sku) => sku.skuNumber === skuNumber);
        totals.bv += quantity * sku.bv;
        totals.pv += quantity * sku.pv;
        totals.subTotal += quantity * sku.price;
    }
    return totals;
}
